module.exports = __webpack_public_path__ + "static/main4_pc-fded606e19b3044aac9110cdfc67e987.jpg";